module.exports = __webpack_public_path__ + "static/media/landing1.d7916af5.png";